<ng-container *ngIf="filterVm$ | async; let vm">
  <ng-template #headerSectionTop>
    <div
      class="header-section"
      [class.tablet]="platformType === PlatformEnum.tablet"
      [class.mobile]="platformType === PlatformEnum.mobile"
      [class.is-windows]="isWindows"
    >
      <ng-container *ngIf="platformType !== PlatformEnum.mobile">
        <h1 data-cy="title-text">
          {{ title | uppercase }}
        </h1>
        <div *ngIf="showShare" class="header-buttons">
          <app-share-print-download
            [showPrint]="platformType === PlatformEnum.desktop"
            [showShare]="platformType === PlatformEnum.tablet"
            (downloadButtonClick)="downloadAll()"
            (shareButtonClick)="share()"
            (printButtonClick)="printAll()"
          ></app-share-print-download>
        </div>
      </ng-container>
    </div>
  </ng-template>
  <ion-grid *ngIf="!isTouch; else touchMode">
    <ion-row>
      <ion-col>
        <app-breadcrumbs
          data-cy="breadcrumbs"
          [breadcrumbs]="breadcrumbs"
        ></app-breadcrumbs>
        <ng-container [ngTemplateOutlet]="headerSectionTop"></ng-container>
        <app-usf-filtering-banner-desktop
          [filterDateRange]="vm.filterDateLabel"
          [numberOfSelectedFilters]="vm.filterCount"
          [isLoading]="isLoading"
          [showQuickDateFilterOption]="showQuickDateFilterOption"
          [showResetFilterOption]="showResetFilterOption"
          [quickFilters]="quickFilters"
          (quickFiltersClicked)="toggleStatusFilter($event)"
          (filterClicked)="openModal(defaultFilterId)"
          (resetFiltersClicked)="resetFilters()"
          (changeDateFilterClicked)="openModal(defaultDateFilterId)"
        ></app-usf-filtering-banner-desktop>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ng-template #touchMode>
    <div>
      <ng-container [ngTemplateOutlet]="headerSectionTop"></ng-container>
      <ng-container *ngIf="showFilters">
        <app-usf-filtering-banner-tablet
          *ngIf="platformType === PlatformEnum.tablet"
          [filterDateRange]="vm.filterDateLabel"
          [numberOfSelectedFilters]="vm.filterCount"
          [isLoading]="isLoading"
          [showQuickDateFilterOption]="showQuickDateFilterOption"
          [showResetFilterOption]="showResetFilterOption"
          [quickFilters]="quickFilters"
          (quickFiltersClicked)="toggleStatusFilter($event)"
          (filterClicked)="openModal(defaultFilterId)"
          (resetFiltersClicked)="resetFilters()"
          (changeDateFilterClicked)="openModal(defaultDateFilterId)"
        ></app-usf-filtering-banner-tablet>
        <app-usf-filtering-banner-mobile
          *ngIf="platformType === PlatformEnum.mobile"
          [filterDateRange]="vm.filterDateLabel"
          [numberOfSelectedFilters]="vm.filterCount"
          [isLoading]="isLoading"
          [showQuickDateFilterOption]="showQuickDateFilterOption"
          [showResetFilterOption]="showResetFilterOption"
          [quickFilters]="quickFilters"
          [showDateRange]="true"
          [showShareDownloadButton]="showShare"
          (quickFiltersClicked)="toggleStatusFilter($event)"
          (filterClicked)="openModal()"
          (resetFiltersClicked)="resetFilters()"
          (changeDateFilterClicked)="openModal(defaultDateFilterId)"
          (shareDownloadClicked)="shareDownload()"
        ></app-usf-filtering-banner-mobile>
      </ng-container>
    </div>
  </ng-template>
</ng-container>
